import BaseModel from './BaseModel'
import Event from './Event'
import EventInventoryTier from './EventInventoryTier'
import { EventTier } from './EventTier'
// import LocationProduct from './LocationProduct'
import buildQuerystring from '../utils/buildQuerystring'
import { Temporal } from '@js-temporal/polyfill'
import { Weekday, PythonWeekday } from '../types/misc'

/**
 * Inventories are not saved to the store.
 * @todo Add types for API methods.
 */
export class Inventory extends BaseModel {

  static entity = 'inventories'
  static primaryKey = 'ID'

  declare ID: number
  declare locationProductID: number
  declare date: string
  declare eventID: number | null
  declare spacesSold: number
  declare spacesTotal: number
  declare event: Event
  declare eventInventoryTier: EventInventoryTier
  declare eventTiers: EventTier[]
  // declare locationProduct: LocationProduct

  static fields() {

    return {

      // fields
      ID: this.number(null),
      locationProductID: this.number(null),
      date: this.string(''),
      eventID: this.number(null).nullable(),
      spacesSold: this.number(null),
      spacesTotal: this.number(null),

      // relationships
      event: this.belongsTo(Event, 'eventID'),
      eventInventoryTier: this.hasOne(EventInventoryTier, 'inventoryID'),
      eventTiers: this.hasMany(EventTier, 'inventoryID'),
      // locationProduct: this.belongsTo(LocationProduct, 'locationProductID'),

    }

  }

  /**
   * API methods
   */

  /**
   * @deprecated. Use getByLocationId() instead.
   */
  static fetchByLocationID(locationID: number, options: object = {}) {

    let url = '/locations/' + locationID + '/inventory'
    url += buildQuerystring(options, [
      'verticalType',
      'start',
      'end',
    ])

    return this.api().get(url, {
      dataKey: 'inventory',
      save: false,
    })

  }

  static getByLocationId(locationId: number, options?: GetInventoryByLocationIdOptions): Promise<GetInventoryByLocationIdResponse> {

    return this.api().get(`locations/${locationId}/inventory`, {
      params: {
        vertical: options?.vertical,
        start: options?.start?.toString(),
        end: options?.end?.toString(),
      },
      save: false,
    })
    .then((result): GetInventoryByLocationIdResponse => {
      result.response.data.inventory.forEach((i: any) => i.date = Temporal.PlainDate.from(i.date))
      return result.response.data.inventory
    })

  }

  /**
   * @deprecated Use updateByLocationId() instead.
   */
  static updateByLocationID(locationID: number, payload: object) {
    return this.api().put('/locations/' + locationID + '/inventory', payload, {
      save: false,
    })
  }

  static updateByLocationId(locationId: number, request: UpdateInventoryByLocationIdRequest) {

    const payload = {
      startDate: request.start.toString(),
      endDate: request.end.toString(),
      weekdays: request.weekdays.map((w: Weekday) => {
        const weekdayName = Weekday[w]
        return PythonWeekday[weekdayName as keyof typeof PythonWeekday]
      }), // BE uses
      inventories: request.inventories.map(i => {
        return {
          locationProductID: i.locationProductId,
          spacesTotal: i.spacesTotal,
          eventID: i.eventId ?? null,
        }
      })
    }

    return this.api().put(`/locations/${locationId}/inventory`, payload, {
      save: false,
    })

  }

}

export interface GetInventoryByLocationIdOptions {
  vertical?: string
  start?: Temporal.PlainDate
  end?: Temporal.PlainDate
}

export interface InventoryObject {
  ID: number
  locationProductID: number
  date: Temporal.PlainDate
  eventID: number | null
  spacesTotal: number
}

export type GetInventoryByLocationIdResponse = InventoryObject[]

export interface UpdateInventoryByLocationIdRequest {
  start: Temporal.PlainDate
  end: Temporal.PlainDate
  weekdays: Weekday[]
  inventories: {
    locationProductId: number
    spacesTotal: number
    eventId?: number
  }[],
}
